import EmissionWelcomeInstruction from '../models/EmissionWelcomeInstruction';

const idDocument = 'Cédula o pasaporte';
const numbRUC = 'No. de RUC de la empresa';
const finalDataBenefit = 'Datos del beneficiario final';
const imageEmissionLegalWelcome = 'emission_legal_welcome.svg';

export const forVehicle: EmissionWelcomeInstruction = {
  documents: [idDocument],
  image: 'emission_welcome.svg',
};

export const forNewVehicle: EmissionWelcomeInstruction = {
  documents: [idDocument, 'Proforma de auto nuevo'],
  image: 'emission_welcome.svg',
};

export const forVehicleRC: EmissionWelcomeInstruction = {
  documents: [idDocument, 'Registro vehicular'],
  image: 'emission_rc_welcome.svg',
};

export const forLegalEntity: EmissionWelcomeInstruction = {
  documents: [numbRUC, finalDataBenefit],
  image: imageEmissionLegalWelcome,
};

export const forLegalEntityNewCCRC: EmissionWelcomeInstruction = {
  documents: [numbRUC, finalDataBenefit, 'Proforma de auto nuevo'],
  image: imageEmissionLegalWelcome,
};

export const forLegalEntityRC: EmissionWelcomeInstruction = {
  documents: [numbRUC, finalDataBenefit, 'Registro vehicular'],
  image: imageEmissionLegalWelcome,
};
